import { createReducer, on } from '@ngrx/store';
import { Action } from '@ngrx/store';
import * as SlideTextActions from '../actions/slide-text.actions';
import { ExaminationSlideText, ExaminationSlideTextList } from '../../model/examinationSlides.model';

export interface SlideTextsData {
    slideText: ExaminationSlideTextList | null,
    selectedSlideText: ExaminationSlideText | null,
    loading: boolean
}

export const initialState: SlideTextsData = {
    slideText: null,
    selectedSlideText: null,
    loading: false,
};

const documentFormationReducer = createReducer(
    initialState,
    on(SlideTextActions.GetSlideText, (state) => ({ ...state, loading: true })),
    on(SlideTextActions.GetSlideTextfromurl, (state) => ({ ...state, loading: true })),
    on(SlideTextActions.GetSlideTextSuccess, (state, action) => ({ ...state, slideText: action.payload, loading: false })),
    on(SlideTextActions.GetSlideTextFailure, (state) => ({ ...state, slideText: null, loading: false })),
    on(SlideTextActions.SetSlideText, (state, action) => ({ ...state, selectedSlideText: action.slideText, loading: false })),
);

export function reducer(state: SlideTextsData | undefined, action: Action) {
    return documentFormationReducer(state, action);
}